/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VoiceAgentProtocolEnum } from './VoiceAgentProtocolEnum';
import {
  VoiceAgentProtocolEnumFromJSON,
  VoiceAgentProtocolEnumFromJSONTyped,
  VoiceAgentProtocolEnumToJSON,
} from './VoiceAgentProtocolEnum';

/**
 *
 * @export
 * @interface VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate
 */
export interface VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate {
  /**
   *
   * @type {VoiceAgentProtocolEnum}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate
   */
  protocol: VoiceAgentProtocolEnum;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate
   */
  credentialValue?: string | null;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate
   */
  name: string;
  /**
   *
   * @type {Date}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate
   */
  environment: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate
   */
  domain?: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate
   */
  voice?: string;
  /**
   *
   * @type {number}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate
   */
  maxDuration?: number;
  /**
   *
   * @type {number}
   * @memberof VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate
   */
  credentialId?: number | null;
}

/**
 * Check if a given object implements the VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate interface.
 */
export function instanceOfVoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate(
  value: object,
): value is VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('environment' in value) || value['environment'] === undefined) return false;
  if (!('tenant' in value) || value['tenant'] === undefined) return false;
  return true;
}

export function VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreateFromJSON(
  json: any,
): VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate {
  return VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreateFromJSONTyped(json, false);
}

export function VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate {
  if (json == null) {
    return json;
  }
  return {
    protocol: VoiceAgentProtocolEnumFromJSON(json['protocol']),
    credentialValue: json['credential_value'] == null ? undefined : json['credential_value'],
    name: json['name'],
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    environment: json['environment'],
    tenant: json['tenant'],
    region: json['region'] == null ? undefined : json['region'],
    domain: json['domain'] == null ? undefined : json['domain'],
    voice: json['voice'] == null ? undefined : json['voice'],
    maxDuration: json['max_duration'] == null ? undefined : json['max_duration'],
    credentialId: json['credential_id'] == null ? undefined : json['credential_id'],
  };
}

export function VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreateToJSON(
  value?: VoiceAgentInferencerCreatePolymorphicVoiceAgentInferencerCelinaCreate | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: VoiceAgentProtocolEnumToJSON(value['protocol']),
    credential_value: value['credentialValue'],
    name: value['name'],
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    environment: value['environment'],
    tenant: value['tenant'],
    region: value['region'],
    domain: value['domain'],
    voice: value['voice'],
    max_duration: value['maxDuration'],
    credential_id: value['credentialId'],
  };
}
